import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/auth';
import { useProfileStore } from '../../stores/profileStore';
import { useMFAStore } from '../../stores/mfaStore';
import { useMFARequired } from '../../hooks/useMFARequired';
import { LoadingSpinner } from '../LoadingSpinner';
import { AuthMFA } from '../auth/AuthMFA';

interface AdminRouteProps {
  children: React.ReactNode;
}

export function AdminRoute({ children }: AdminRouteProps) {
  const { user, loading: authLoading } = useAuth();
  const { profile } = useProfileStore();
  const { requireMFA, checking: checkingMFA } = useMFARequired();
  const { markMfaVerified } = useMFAStore();
  const location = useLocation();

  if (authLoading) return <LoadingSpinner />;

  if (!user) {
    return (
      <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}` }} />
    );
  }

  if (!profile) {
    return <LoadingSpinner />;
  }

  if (profile.role !== 'administrator') {
    return <Navigate to="/dashboard" replace />;
  }

  if (profile.status !== 'active') {
    return (
      <Navigate to="/signup" replace state={{ from: `${location.pathname}${location.search}` }} />
    );
  }

  // Block until the MFA check resolves so admin content never flashes for an AAL1 session
  if (checkingMFA) return <LoadingSpinner />;

  if (requireMFA) {
    return <AuthMFA onVerified={() => markMfaVerified()} />;
  }

  return <>{children}</>;
}
